import { useMemo } from 'react';
import { useMatches, useParams } from 'react-router';
import { navigateToRoute } from 'src/navigation/routes';
import { IDoctorProfileDto, IDoctorStudyDto } from 'src/services/api/api-client';
import { useGetDoctorProfileInfoQuery } from 'src/services/api/api-client/ProfileQuery';

const defaultDoctorDto: IDoctorProfileDto = {
  id: '',
  fullName: '',
  email: null,
  studies: [],
};

export const useStaffProfile = (options?: { enabled?: boolean; suspense?: boolean }) => {
  const doctorQuery = useGetDoctorProfileInfoQuery({
    keepPreviousData: true,
    refetchOnMount: false,
    ...options,
  });

  return useMemo(
    () => ({
      profile: doctorQuery.data ?? defaultDoctorDto,
      query: doctorQuery,
    }),
    [],
  );
};

export const useStudy = (): IDoctorStudyDto | undefined => {
  const { studyId } = useParams();
  const data = useRouteData<{ study: IDoctorStudyDto | undefined }>(navigateToRoute.dashboard(Number(studyId)));
  return data?.study;
};

export const useRouteData = <T>(routePath: string): T | undefined => {
  const matches = useMatches();
  const data = matches.find((match) => match.pathname === routePath)?.data;
  return data as T | undefined;
};
